import { AccredibleOrganizationSettings } from '@accredible-frontend-v2/models';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  organizationSettings$: Observable<AccredibleOrganizationSettings>;

  googleHeaderLinks = [
    {
      id: 'rmi-home',
      label: this._language.selectTranslate(
        'googlecloudcertified_credential_net.header.certifications_home',
      ),
      externalLink: 'https://cloud.google.com/certification',
    },
    // TODO: Replace TODO with actual link when available
    // {
    //   id: 'rmi-certifications',
    //   label: this._language.selectTranslate(
    //     'google_cloud_credential_net.header.learning_certification',
    //   ),
    //   externalLink: 'TBD',
    // },
    {
      id: 'rmi-contact-us',
      label: this._language.selectTranslate(
        'googlecloudcertified_credential_net.header.contact_us',
      ),
      externalLink: 'https://support.google.com/cloud-certification/gethelp',
    },
  ];

  constructor(private _language: AccredibleLanguageService) {}
}
